import { REGIONS } from '@constants/regions';
import { getEnv } from '@config';

const { country } = getEnv();
const { decimalCount: maximumFractionDigits, currency, locale } = REGIONS[country];

const clean = (number) => {
  if (typeof number === 'number') {
    return number;
  }

  // strips everything that is not a number (positive or negative)
  return Number(number.toString().replace(/[^0-9-]/g, ''));
};

export const normalizeValue = (number) => {
  if (!number) return 0;
  number = clean(number);
  if (maximumFractionDigits === 0 || Number.isInteger(number)) {
    if (number > 0) return Math.floor(number);
    return Math.ceil(number);
  }
  /** No need to truncate decimals because PISMO returns a maximum of two decimals */
  return number;
};

export const moneyFormat = (number = 0, showSymbol = true) => {
  let options = {};
  if (showSymbol) {
    options = {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
      minimumFractionDigits: maximumFractionDigits,
      maximumFractionDigits,
    };
  } else {
    options = {
      style: 'decimal',
      minimumFractionDigits: maximumFractionDigits,
      maximumFractionDigits,
    };
  }
  const sign = number < 0 ? '-' : '';
  return `${sign}${new Intl.NumberFormat(locale, options).format(Math.abs(number))}`;
};
